import { asPercentage } from '../utils/formatters';

export default [
  {
    displayString: 'Loss Event',
    accessor: 'name',
  },
  {
    displayString: 'Starting Year',
    accessor: 'startingYear',
  },
  {
    displayString: 'Ending Year',
    accessor: 'endingYear',
  },
  {
    displayString: 'Event Cadence',
    accessor: 'cadence',
    format: (n) => `Every ${n} year${n === 1 ? '' : 's'}`,
  },
  {
    displayString: '% Yield Loss',
    accessor: 'percentLoss',
    format: asPercentage,
  },
  {
    displayString: '% Tree Loss',
    accessor: 'percentTreeLoss',
    format: asPercentage,
  },
];
